import React from 'react'
import OwlCarousel from 'react-owl-carousel'
import '../assets/owl carousel/owl.carousel.min.css'
import '../assets/owl carousel/owl.theme.default.min.css'
// Components
import LinksMap from '../components/LinksMap'
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/about.css'
import { Link } from 'react-router-dom'

export default function About() {
  return (
    <div className='about_page'>
      <PageTransition />
      
      <LinksMap linksArr={[{name: 'Home', path: '/', active: false}, {name: 'About Us', path: '/about', active: true}]} pageName='About Us' />
      <div className='banner'>
        <div className='container'>
          <div className='details'>
            <div className='title'>About Us</div>
            <span>OUR COMPANY</span>
            <Link to='/contact'>CONTACT</Link>
          </div>
        </div>
      </div>
      <div className='container'>
        <div className='about_text'>
          <div className='title'>OUR STORY</div>
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. <br /><br />Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
          <span className='quoto'>“ Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model search for evolved over sometimes by accident, sometimes on purpose ”</span>
        </div>
      </div>

      <div className='why_choose_us'>
        <div className='container'>
          <div className='section_title'>Why Choose Us</div>

          <div className='content'>
            <div className='item'>
              <div className='icon'>
                <img src={require('../assets/icons/shipping.png')} />
              </div>
              <div className='name'>Free Shipping</div>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industr.</p>
            </div>
            <div className='item'>
              <div className='icon'>
                <img src={require('../assets/icons/dollar.png')} />
              </div>
              <div className='name'>100% money back guarantee.</div>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industr.</p>
            </div>
            <div className='item'>
              <div className='icon'>
                <img src={require('../assets/icons/support.png')} />
              </div>
              <div className='name'>Online Support 24/7</div>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industr.</p>
            </div>
          </div>
        </div>
      </div>

      <div className='reviews'>
        <div className='container'>
          <div className='section_title'>Happy Clients</div>
          
          <div className='content'>
            <OwlCarousel
              className='owl-theme'
              items={3}
              autoPlay={true}
              autoplayHoverPause={true}
              
              autoplaySpeed={1000}
              responsive={{
                720: {items: 3},
                500: {items: 2},
                0: {items: 1}
              }}
              dots={true}
              margin={10}
            >
              <div className='item'>
                <div className='reviewer_info'>
                  <div className='image'>
                    <img src='https://via.placeholder.com/150' />
                  </div>
                  <div className='details'>
                    <div className='name'>John Doe</div>
                    <span>SMARTWAVE CEO</span>
                  </div>
                </div>
                <div className='review_text'>
                  <img src={require('../assets/icons/quote.png')} />
                  <p>Lorem ipsum dolor sit amet, consectetur elitad adipiscing Cras non placerat mipsum dolor sit amet, consectetur elitad adipiscing cas non placerat mi.</p>
                </div>
              </div>
              <div className='item'>
                <div className='reviewer_info'>
                  <div className='image'>
                    <img src='https://via.placeholder.com/150' />
                  </div>
                  <div className='details'>
                    <div className='name'>John Doe</div>
                    <span>SMARTWAVE CEO</span>
                  </div>
                </div>
                <div className='review_text'>
                  <img src={require('../assets/icons/quote.png')} />
                  <p>Lorem ipsum dolor sit amet, consectetur elitad adipiscing Cras non placerat mipsum dolor sit amet, consectetur elitad adipiscing cas non placerat mi.</p>
                </div>
              </div>
              <div className='item'>
                <div className='reviewer_info'>
                  <div className='image'>
                    <img src='https://via.placeholder.com/150' />
                  </div>
                  <div className='details'>
                    <div className='name'>John Doe</div>
                    <span>SMARTWAVE CEO</span>
                  </div>
                </div>
                <div className='review_text'>
                  <img src={require('../assets/icons/quote.png')} />
                  <p>Lorem ipsum dolor sit amet, consectetur elitad adipiscing Cras non placerat mipsum dolor sit amet, consectetur elitad adipiscing cas non placerat mi.</p>
                </div>
              </div>
              <div className='item'>
                <div className='reviewer_info'>
                  <div className='image'>
                    <img src='https://via.placeholder.com/150' />
                  </div>
                  <div className='details'>
                    <div className='name'>John Doe</div>
                    <span>SMARTWAVE CEO</span>
                  </div>
                </div>
                <div className='review_text'>
                  <img src={require('../assets/icons/quote.png')} />
                  <p>Lorem ipsum dolor sit amet, consectetur elitad adipiscing Cras non placerat mipsum dolor sit amet, consectetur elitad adipiscing cas non placerat mi.</p>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </div>

      <div className='statistics'>
        <div className='container'>
          <div className='item'>
            <div className='count'>200<span>+</span></div>
            <p>MILLION CUSTOMERS</p>
          </div>
          <div className='item'>
            <div className='count'>1800<span>+</span></div>
            <p>TEAM MEMBERS</p>
          </div>
          <div className='item'>
            <div className='count'>24<span>HR</span></div>
            <p>SUPPORT AVAILABLE</p>
          </div>
          <div className='item'>
            <div className='count'>265<span>+</span></div>
            <p>CUP OF COFFEE</p>
          </div>
          <div className='item'>
            <div className='count'>99<span>%</span></div>
            <p>POSITIVE REVIEWS</p>
          </div>
        </div>
      </div>
    </div>
  )
}
